import {useLocation} from 'react-router-dom';
import {matchBreadcrumbRoute} from './breadcrumbRoutes';
import usePreservedSearchString from './usePreservedSearchString';

/**
 * Returns the "back" destination for the current breadcrumb route, or `null`
 * if the current path doesn't match any breadcrumb route.
 *
 * The back destination is derived directly from the breadcrumb items —
 * specifically, the last item that has a `link`. Current search params
 * (excluding versionId) are appended so filters are preserved on navigation.
 */
function useBreadcrumbsBack(): string | null {
  const {pathname} = useLocation();
  const preservedSearch = usePreservedSearchString();
  const matched = matchBreadcrumbRoute(pathname);

  if (!matched) {
    return null;
  }

  const items = matched.route.getItems(matched.params, {});
  const backItem = [...items].reverse().find((item) => item.link);
  return backItem?.link ? backItem.link + preservedSearch : null;
}

export default useBreadcrumbsBack;
